var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoLibraryWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.23801 8H16.7618C17.8094 8 18.6666 8.9 18.6666 10V20C18.6666 21.1 17.8094 22 16.7618 22H7.23801C6.19039 22 5.33325 21.1 5.33325 20V10C5.33325 8.9 6.19039 8 7.23801 8ZM6.28563 6.5H17.7142C17.7142 5.67 17.0761 5 16.2856 5H7.7142C6.92373 5 6.28563 5.67 6.28563 6.5ZM7.23801 3.5H16.7618C16.7618 2.67 16.1237 2 15.3333 2H8.66659C7.87611 2 7.23801 2.67 7.23801 3.5ZM15.1666 15.494C15.611 15.2374 15.611 14.5959 15.1666 14.3393L10.2916 11.5247C9.84714 11.2681 9.29159 11.5889 9.29159 12.1021L9.29159 17.7312C9.29159 18.2444 9.84714 18.5652 10.2916 18.3086L15.1666 15.494Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoLibraryWhite);
export default __webpack_public_path__ + "static/media/VideoLibraryWhite.590228d2a7e697780c1fc6aa6cd67663.svg";
export { ForwardRef as ReactComponent };